import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { updateOrdersAction } from "../../MyApi/orders";
import EnhancedSearchProduct from "../../Components/UI/enhancedproductsearch";

const ReplaceModal = ({ isOpen, toggle, orderId, onSuccess, items:orderItems  ,orderData ,refetchOrder}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [replacementProductId, setReplacementProductId] = useState("");
  const [reason, setReason] = useState("");

  const[productName , setProductName] = useState("");
  
  // Determine if this is a multi-store order
  const isMultiStore = Array.isArray(orderItems) && orderItems.length > 0 && orderItems[0].store;
  console.log('orderItems', selectedItem)
  // For display purposes, create a structure that works for both single and multi-store
  const displayItems = isMultiStore ? orderItems : [{ store: null, items: orderItems }];
  
  // Get store ID for EnhancedSearchProduct (use first selected item's store or null for multi-store)
  const getSelectedStoreId = () => {
    if (!selectedItem) return null;
   
    
    // If multi-store, find the store for the first selected item
    if (isMultiStore) {
      for (const storeGroup of orderItems) {
        const foundItem = storeGroup.items.find(item => item.id === selectedItem.id);
        if (foundItem) {
          return storeGroup.store?.id;
        }
      }
    }
    
    // For single store, use the item's store_id or first item's store_id
    return orderData.data?.order?.store?.id
  };
console.log('first', getSelectedStoreId())
  const getOrderIdForSelectedItem = () => {
  if (!selectedItem) return null; // fallback to parent

  // Multi-store: find the child order that contains the selected item
  if (orderData.data?.order.children?.length > 0) {
    for (const childOrder of orderData.data.order.children) {
      const foundItem = childOrder.items.find(item => item.id === selectedItem.id);
      if (foundItem) {
        return childOrder.id; // send the child order ID
      }
    }
  }

  // Single-store: use main order ID
  return orderId;
};
  
  const storeId = getSelectedStoreId();
console.log('first', storeId)
  const toggleItem = (item) => {
    setSelectedItem((prev) =>
      prev?.id === item.id ? null : item
    );
  };
console.log('selectedItem', selectedItem)
  const mutation = useMutation(
    (replaceData) => updateOrdersAction(replaceData, getOrderIdForSelectedItem()),
    {
      onSuccess: (data) => {
        toast.success("تم استبدال المنتج بنجاح");
        onSuccess();
        toggle();
        // Reset form
        refetchOrder()
        setSelectedItem(null);
        setReplacementProductId("");
        setReason("");
      },
      onError: (error) => {
        toast.error("فشل في استبدال المنتج");
      }
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedItem) {
      toast.error("يرجى اختيار منتج للإستبدال");
      return;
    }
    
    if (!replacementProductId) {
      toast.error("يرجى اختيار المنتج البديل");
      return;
    }
    
    if (!reason.trim()) {
      toast.error("يرجى إدخال سبب الاستبدال");
      return;
    }

  
const requestData = {
  action_type: "replace_item",
  order_item_id: selectedItem.id,
  replacement_item_id: replacementProductId,
  reason: reason
};

mutation.mutate(requestData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "reason") {
      setReason(value);
    }
  };
const setProductId = (productId , name) => {
    setReplacementProductId(productId);
    setProductName(name);
  }
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        استبدال منتج
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          {/* Select Order Items to Replace */}
          <div className="mb-4">
            <label className="form-label fw-bold mb-3 d-block">اختر المنتج المراد استبداله:</label>
            {displayItems.map((storeGroup, storeIndex) => (
              <div key={storeIndex}>
                {storeGroup.store && (
                  <div className="store-header mb-3 p-3 bg-light rounded">
                    <h6 className="mb-1">
                      {storeGroup.store.name} 
                      <span className="badge bg-secondary ms-2">رقم: {storeGroup.store.id}</span>
                    </h6>
                  </div>
                )}
                {storeGroup.items.map((item) => (
                  <div
                    key={item.id}
                    className="d-flex align-items-center justify-content-between border-bottom py-2"
                  >
                    <div className="d-flex align-items-center gap-3">
                      <input
                           type="radio" // changed from checkbox
        name="selectedItem" // same name ensures only one selection
                        onChange={() => toggleItem(item)}
                                checked={selectedItem?.id === item.id}
                                disabled={item.action_status === "refunded" || item.action_status === "replaced"}

                      />
                      <img
                        src={item.product?.image}
                        width="45"
                        height="45"
                        style={{ objectFit: "cover", borderRadius: "6px" }}
                      />
                      <div>
                        <div className={`fw-bold ${item.action_status === "replaced"  ? "text-muted" : item.action_status === "refunded"?"text-danger":  "text-dark"}`}>
                          {item.product?.name} ({item.action_status === "replaced" ? "تم استبداله" : item.action_status === "refunded" ? "تم استرداده" : "قيد المعالجة"})
                        </div>
                        <div className="small text-muted">
                          الكمية: {item.quantity}
                        </div>
                      </div>
                    </div>
                    <div className="fw-bold text-danger">
                      {(item.total_price / item.currency_factor).toLocaleString()} {item.symbol_currency}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Select Replacement Product using EnhancedSearchProduct */}
          <div className="mb-4">
            <label className="form-label fw-bold">اختر المنتج البديل من المنتجات:</label>
            <EnhancedSearchProduct
              setProductId={setProductId}
         
              storeId={storeId}
              isMulti={false}
              value={replacementProductId ? { id: replacementProductId, name: productName } : null}
            />
          </div>

          {/* Reason for Replacement */}
          <div className="mb-3">
            <label className="form-label">السبب</label>
            <textarea
              className="form-control"
              name="reason"
              value={reason}
              onChange={handleChange}
              rows="3"
              placeholder="مثلاً: تم إرسال المقاس الخطأ، الاستبدال للحصول على المقاس الصحيح"
              required
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button 
              type="button" 
              className="btn btn-white" 
              onClick={toggle}
              disabled={mutation.isLoading}
            >
              إلغاء
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={mutation.isLoading || !selectedItem || !replacementProductId || !reason.trim()}
            >
              {mutation.isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  جاري المعالجة...
                </>
              ) : (
                "إرسال طلب الاستبدال"
              )}
            </button>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default ReplaceModal;